const SidebarOpenState = {
	OPEN: 'open',
	MINIMAL: 'minimal',
	CLOSED: 'closed',
} as const;

export default SidebarOpenState;
